import { render, staticRenderFns } from "./SpireBloodResultsIndexComponent.vue?vue&type=template&id=1da15eac"
import script from "./SpireBloodResultsIndexComponent.vue?vue&type=script&lang=js"
export * from "./SpireBloodResultsIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports